import axios from '@/node-modules/axios'

const getPresentation = async (moderationCode: any) => {
  const res = await axios.get(`/presentation/backstage/${moderationCode}`)

  return res.data
}

export default {
  getPresentation,
}
